import config from "config/config";
import { getToken } from "js/formatting/getToken";

export async function exportPolicies(policyType, contractIds) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      contractIds: contractIds,
      policyStatus: policyType,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/policy/status",
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const filename = `${policyType} Policies.xlsx`;
    const blob = await response.blob();
    const a = document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return response;
  }
}
